"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function Udp(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M22 0c1.1 0 2 .9 2 2v20c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2V2C0 .9.9 0 2 0zm0 2H2v20h20V2zM6.7 9.068v3.305c.013.545.265.818.757.818.248 0 .437-.068.564-.205.127-.137.192-.359.192-.668v-3.25h1.2v3.258c0 .37-.079.69-.237.96a1.546 1.546 0 0 1-.676.616c-.295.141-.64.211-1.043.211-.606 0-1.084-.156-1.432-.47-.349-.315-.527-.747-.533-1.294V9.07H6.7zm5.063 0c.442 0 .836.1 1.188.3.35.198.625.481.822.845.197.363.297.77.3 1.22v.23c0 .456-.099.864-.29 1.226a2.123 2.123 0 0 1-.815.847 2.31 2.31 0 0 1-1.17.31h-1.636V9.067h1.601zm4.909 0c.38 0 .719.07 1.012.212.293.14.519.339.68.597.16.26.24.553.24.88 0 .486-.174.874-.522 1.165-.347.289-.824.436-1.43.436h-.765v1.687h-1.2V9.069h1.985zm-4.909.926h-.402v3.13h.416c.346 0 .61-.124.793-.368.186-.246.277-.61.277-1.094v-.215c0-.48-.09-.842-.277-1.086-.184-.244-.453-.367-.807-.367zm4.923 0h-.8v1.436h.786c.233 0 .41-.057.533-.174.12-.115.182-.28.182-.492 0-.232-.063-.418-.188-.557a.675.675 0 0 0-.513-.213z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = Udp;
